import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Button, Modal } from 'react-bootstrap';
import { FeatureGroup, Map, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import { EditControl } from 'react-leaflet-draw';
import moment from 'moment-timezone';
import i18next from 'i18next';

import { SelectInput } from '../SelectInput';
import { TextInput } from '../TextInput';
import { CheckboxInput } from '../CheckboxInput';
import GroupingImage from './grouping_image';


const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Please Enter Group Name';
  }
  if (!values.deviceGroup) {
    errors.deviceGroup = 'Please Select Device Group';
  }
  if (!values.timezone) {
    errors.timezone = 'Please Select a Timezone';
  }

  return errors
}

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-icon.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0/images/marker-shadow.png',
});
class GroupingForm extends React.Component {

  constructor(props) {
    
    super(props);

    const initData = {
      name: props.groupName,
      deviceGroup: props.selectedGroup,
      timezone: props.groupTimezone ? {value:props.groupTimezone, label: props.groupTimezone} 
                                    : {value: 'America/Kentucky/Louisville', label: 'America/Kentucky/Louisville'},
      tzReq: props.groupTimeReq,
      bounds: props.groupingBounds,
      actionsEnabled: props.actionsEnabled
    };

    let imageName;

    if(props.metadata) {
      props.metadata.forEach(entry => {
        if (entry.deviceGroupingMetadataType.token === 'img') {
          imageName = entry.stringValue;
        } else {
          initData[entry.deviceGroupingMetadataType.name] = entry.stringValue;
        }
      });
    }

    this.props.initialize(initData);

    this.state = {
      lgShow: false,
      imageName: imageName
    };
  }

  renderAvailableGroups() {
    if (this.props.availableGroups) {
      return (
        <div className="form-group">
          <label>{i18next.t('form-labels.business-structure')}</label>
          <Field
            options={this.props.availableGroups}
            name="deviceGroup"
            clearable={false}
            searchable={true}
            disabled={this.props.availableGroups.length == 1}
            component={SelectInput}
          />
        </div>
      );
    } else {
      return (
        <div className="form-group">
          <label>{i18next.t('form-labels.business-structure')}</label>
          <div>{this.props.selectedGroupName}</div>
        </div>
      );
    }
  }

  hasMapMetadata() {
    let counter = 0
    this.props.types.forEach(function(cur) {
      if (cur.token == "geo_lat") {
        counter++
      } else if (cur.token == "geo_lon") {
        counter++
      } else if (cur.token == "geo_bounds") {
        counter++
      }
    });

    return (counter == 3)
  }

  containsNonMapMetadata() {
    let result = false
    this.props.types.forEach(function(cur) {
      if (cur.token != "geo_lat" && cur.token != "geo_lon" && cur.token != "geo_bounds") {
        result = true
      }
    });
    return result
  }

  handler(newData,lat, long) {
    this.props.updateMapData(newData, lat, long)
  }

  render() {
    var zones = moment.tz.names();

    let zonesObj = zones.map((val, i, arr) => {
      return {
        value: val,
        label: val
      };
    });
    let lat = ""
    let long = ""
    if (this.props.metadata) {
      for (let i = 0; i < this.props.metadata.length; i++) {
        let cur = this.props.metadata[i]
        if (cur.deviceGroupingMetadataType.token == "geo_lat") {
          lat = cur.stringValue
        } else if (cur.deviceGroupingMetadataType.token == "geo_lon") {
          long = cur.stringValue
        }
      }
    }

    const mapDispatchToProps = (dispatch) => {
      return bindActionCreators({change}, dispatch);
    }

    //Modal close state set
    let lgClose = () => this.setState({ lgShow: false });

    let marginB = {marginBottom: '10px'};
    let paddingB = {paddingBottom: '0px'};

    return (
      <div className="op-content-box devices">
        <form onSubmit={this.props.handleSubmit}>
          {this.renderAvailableGroups()}
        
          <div className="form-group">
            <label>{i18next.t('form-labels.group-name')}</label>
            <Field
              type="text"
              name="name"
              component={TextInput}
            />
          </div>
          <div className="form-group">
            <label>{i18next.t('form-labels.actions-enabled')}</label>
            <Field
              className="inline"
              name="actionsEnabled"
              component={CheckboxInput}
              type="checkbox"
              />
          </div>
          {this.props.groupTimeReq &&
          <div className="form-group">
              <label htmlFor="timezone">{i18next.t('timezone')}</label>
              <Field
                options={zonesObj}
                name="timezone"
                clearable={true}
                searchable={true}
                component={SelectInput}
              />
          </div>
          }
          { this.containsNonMapMetadata() &&
          <div className="op-content-box-level-2 action-wrap" style={marginB}>
            <div className="row">
              <div className="col-sm-12">
                <ul className="list-inline clearfix remove-margin-bottom actions-header">
                  <li className="pull-left"><h4 className="remove-margin-bottom">{i18next.t('pages.groups.grouping-metadata')}</h4></li>
                </ul>
              </div>
                <div className="col-sm-12 oc-mini-card">
                  <div className="inner" style={paddingB}>
                    <div className="row">
                      { this.props.types.map((element, index) => element.token != "img" ?
                          (element.token != "geo_bounds" && element.token != "geo_lat" && element.token != "geo_lon") ?
                          <div className="form-group col-sm-12 col-lg-6" key = {index}>
                              <label>{i18next.t(`device-grouping-metadata-types.${element.token}`)}</label>
                              <Field
                                type = "text"
                                name={element.name}
                                component={TextInput}
                              />
                            </div> :

                            <div className = "hidden" key = {index}>
                            <div className="form-group col-sm-12 col-lg-6">
                                <label>{i18next.t(`device-grouping-metadata-types.${element.token}`)}</label>
                                <Field
                                  type = "text"
                                  name={element.name}
                                  component={TextInput}
                                />
                              </div>
                            </div>

                            :

                           <div className="col-sm-4" key = {index} style={{marginBottom: 10}}>
                           <label>{i18next.t(`device-grouping-metadata-types.${element.token}`)}</label>
                              <GroupingImage groupingId={this.props.groupingId} imageName={this.state.imageName}/>
                            </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
          </div>
          }

          {
            this.hasMapMetadata() &&
            <div>
              <Button
                bsStyle="primary"
                onClick={() => this.setState({ lgShow: true })}
              >
                {i18next.t('pages.groups.edit-region-area')}
              </Button>

              <MapModal show={this.state.lgShow} onHide={lgClose} boundsData={this.props.groupingBounds} lat = {lat} long = {long} handler={this.handler.bind(this)}/>
            </div>
          }

          <hr />
          <ul className="list-inline clearfix">
            <li><button type="submit" className="btn btn-primary">{i18next.t('form-labels.save')}</button></li>
          </ul>
        </form>
      </div>
    );
  }

}

class MapModal extends React.Component {
  update(bounds, markerBounds) {
    if (markerBounds[0] > bounds[0][0] && markerBounds[0] > bounds[1][0]) {
      bounds[1][0] = markerBounds[0]
    }
    else if (markerBounds[0] < bounds[0][0] && markerBounds[0] < bounds[1][0]) {
      bounds[0][0] = markerBounds[0]
    }
    if (markerBounds[1] > bounds[0][1] && markerBounds[1] > bounds[1][1]) {
      bounds[1][1] = markerBounds[1]
    }
    else if (markerBounds[1] < bounds[0][1] && markerBounds[1] < bounds[1][1]) {
      bounds[0][1] = markerBounds[1]
    }
    return bounds
  }
  close() {
    this.layer = null
    this.oldLayer = null
    this.props.onHide()
  }

  render() {
    var _editableFG = null;
    var mapBounds = null;
    var points = this.props.boundsData;
    var layer = null;
    var map = null;

    var _onFeatureGroupReady = (reactFGref) => {
      let leafletFG = reactFGref;
      this._editableFG = reactFGref;
    }

    const myCustomColour = '#ff0000'

    const markerHtmlStyles = `
      background-color: ${myCustomColour};
      width: 3rem;
      height: 3rem;
      display: block;
      left: -1.5rem;
      top: -1.5rem;
      position: relative;
      border-radius: 3rem 3rem 0;
      transform: rotate(45deg);
      border: 1px solid #FFFFFF`

    const icon = L.divIcon({
      className: "my-custom-pin",
      iconAnchor: [0, 24],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -36],
      html: `<span style="${markerHtmlStyles}" />`
    })


    var handleLeafletLoad = (event) => {
      var currBounds = document.getElementsByClassName("current-bounds")
      if (currBounds.length == 0) {
        let fgVar = this._editableFG;
        this.mapBounds = findGroupingBounds(this.props.boundsData);
        let boundFit =  findGroupingBounds(this.props.boundsData)
        var map = event.target._map;
        map.on(L.Draw.Event.CREATED, function (e) {
           var type = e.layerType,
               layer = e.layer;
           if (type === 'marker') {
             if (this.lastMarker) {
               map.removeLayer(this.lastMarker);
             }
             this.lastMarker = e.layer
           }
           if (type === 'rectangle') {
             if (this.lastRect) {
               map.removeLayer(this.lastRect);
             }
             this.lastRect = e.layer
           }
        });
        if (this.props.lat && this.props.long) {
          this.markerBounds = [this.props.lat, this.props.long]
          let markerRect = L.marker(this.markerBounds, {icon: icon}).addTo(map);
          if (boundFit[0])
            boundFit = this.update(boundFit,this.markerBounds)
        }
        if(this.mapBounds[0]) {
          let boundRect = L.rectangle(this.mapBounds, {stroke: "#bb1111", strokeOpacity: 0.5, strokeWidth: 4, color: "#ff4444", weight: 1, fillOpacity: 0.2, className: "current-bounds"}).addTo(map);
        }
        if (boundFit[0]) {
          map.fitBounds(boundFit);
        }
      }
    }

    var findGroupingBounds = (groupingMetadata) => {
      let groupingBounds = [];

      const geoboundsMetadata = groupingMetadata.filter(md => md.deviceGroupingMetadataType.token === 'geo_bounds');
      if (geoboundsMetadata && geoboundsMetadata.length > 0) {
          const latLngPairs = geoboundsMetadata[0].stringValue.split(';');

          latLngPairs.forEach(llp => {
              const ll = llp.split(',');
              groupingBounds.push([parseFloat(ll[0]), parseFloat(ll[1])]);
          });

          if (groupingBounds.length > 2) {
              groupingBounds = [ groupingBounds[0], groupingBounds[2] ];
          }
      }

      return groupingBounds;
    }

    var onSave = () => {
      let newPoints = null
      let lat = null
      let lng = null

      if (this.layer._bounds) {
        newPoints = this.layer.toGeoJSON();
        newPoints = formatPoints(newPoints);
      } else if (this.oldLayer && this.oldLayer._bounds) {
        newPoints = this.oldLayer.toGeoJSON();
        newPoints = formatPoints(newPoints);
      }
      if (this.layer._latlng) {
        lat = this.layer._latlng.lat
        lng = this.layer._latlng.lng
      } else if (this.oldLayer && this.oldLayer._latlng) {
        lat = this.oldLayer._latlng.lat
        lng = this.oldLayer._latlng.lng
      }

      this.props.handler(newPoints, lat, lng)

      this.layer = null
      this.oldLayer = null
      this.props.onHide()
    }

    var _onCreate = (e) => {
        if(this.layer) {
          this.oldLayer = this.layer
        }

        var type = e.layerType;
        this.layer = e.layer;
        this.map = e.target._map;
    }

    var formatPoints = (newPoints) => {
      newPoints = newPoints.geometry.coordinates[0];
      let stringCoords = "";

      for (var i = 0; i < newPoints.length - 1; i++) {
        stringCoords += newPoints[i][1];
        stringCoords += ",";
        stringCoords += newPoints[i][0];
        stringCoords += ";";
      }

      return stringCoords;
    }

    return (
      <Modal
        onHide={this.props.onHide}
        show={this.props.show}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">{i18next.t('pages.groups.edit-region-bounds')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bounds-map-key"> <div className="red"> </div> <p> - {i18next.t('pages.groups.current-region-bounds')} </p> </div>
          <div className="bounds-map-key"> <div className="blue"> </div> <p> - {i18next.t('pages.groups.new-region-bounds')} </p> </div>
          <Map id="mapId" center={[33.222,-96.222]} zoom={10}>
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
              onLoad={handleLeafletLoad}
            />
            <FeatureGroup ref={ (reactFGref) => {_onFeatureGroupReady(reactFGref);} }>
                <EditControl
                  position='topright'
                  onCreated={_onCreate}
                  draw={{
                    circle: false,
                    polyline: false,
                    polygon: false,
                    marker: true,
                    circlemarker: false,
                  }}
                />
            </FeatureGroup>
          </Map>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onSave}>{i18next.t('form-labels.save')}</Button>
          <Button onClick={this.close.bind(this)}>{i18next.t('form-labels.close')}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default reduxForm({ form: 'GroupingForm', validate })(GroupingForm);
